import { Component } from "react";
import { withRouter } from "react-router-dom";
import LoadingScreeen from "../components/LoadingScreen";
import MainContent from "../components/boxes/MainContent";
import PageHeader from "../components/boxes/PageHeader";
import PageBody from "../components/boxes/PageBody";
import ChatThreadList from "../components/ChatThreadList";
import { ApiService, ENDPOINTS } from "../services/ApiService";
import { withTranslation } from "react-i18next";
import CareBalanceStatusModal from "../components/care-balance/modals/CareBalanceStatusModal";
import { isFeatureEnabled } from "@reliance/feature-flags";
import { canProductUseCareBalance } from "../components/care-balance/utils/can-product-use-care-balance";
import { features } from "../services/constants";

class ConsultDoctorContainer extends Component {
  constructor(props) {
    super(props);
    this.service = new ApiService(
      props.user.credentials.accessToken,
      props.i18n.language,
    );
    this.state = {
      isLoading: false,
      consultations: [],
    };
  }

  componentDidMount() {
    this.service
      .get(ENDPOINTS.profile.profileDetails)
      .then(() => {
        // temporarily took out loader for modal to be displayed for Egypt
        // this.setLoading(true);
        this.service
          .get(ENDPOINTS.consultations.consultation)
          .then((response) => {
            this.setState({
              isLoading: false,
              consultations: response.data,
            });
          })
          .catch((e) => {
            console.error(e);
          });
      })
      .catch((error) => {
        if (error?.response?.data?.message === "Inactive profile") {
          window.location = "/plan-expired";
        }
      });
  }

  setLoading(isLoading) {
    this.setState({
      isLoading,
    });
  }

  render() {
    const { isLoading, consultations } = this.state;
    const { t } = this.props;

    const { user } = this.props;

    const isActive = user?.planInfo?.active_status_id === 1;

    const canUseCareBalance =
      isFeatureEnabled(features.enableCareBalance) &&
      canProductUseCareBalance(user?.planInfo?.product?.id);

    return (
      <MainContent>
        <PageHeader
          title={
            isLoading
              ? `${t("consultationsLoadingPageTitle")}`
              : `${t("consultADoctorPageTitle")}`
          }
        />
        <PageBody>
          {isLoading ? (
            <LoadingScreeen />
          ) : !isActive && canUseCareBalance ? (
            <CareBalanceStatusModal
              onClose={() => this.props.history.push("/")}
            />
          ) : (
            <ChatThreadList chatThreadList={consultations} />
          )}
        </PageBody>
      </MainContent>
    );
  }
}
const ConsultDoctorContainerWithTranslation = withTranslation([
  "consultations",
])(ConsultDoctorContainer);
export default withRouter(ConsultDoctorContainerWithTranslation);
